// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-tab__pane,\n.van-tab__pane-wrapper {\n  -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n  box-sizing: border-box;\n  width: 100%;\n}\n.van-tab__pane-wrapper--inactive {\n  height: 0;\n  overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
